// Generated by spriteMerger.js
import { ComponentProps } from 'react';
import Icon from '../Icon';
import home from './home.svg';

interface HomeIconProps extends Omit<ComponentProps<typeof Icon>, 'link'> {
  name: HomeNames;
}

export function HomeIcon({ name, ...props }: HomeIconProps) {
  return <Icon {...props} link={home} name={name} />
}

type HomeNames =
  | 'auto_mode'
  | 'blinds_closed'
  | 'blinds'
  | 'broadcast_on_home'
  | 'broadcast_on_personal'
  | 'curtains_closed'
  | 'curtains'
  | 'electric_bolt'
  | 'electric_meter'
  | 'energy_savings_leaf'
  | 'gas_meter'
  | 'heat_pump'
  | 'mode_fan_off'
  | 'nest_cam_wired_stand'
  | 'oil_barrel'
  | 'propane_tank'
  | 'propane'
  | 'roller_shades_closed'
  | 'roller_shades'
  | 'sensor_door'
  | 'sensor_occupied'
  | 'sensor_window'
  | 'shield_moon'
  | 'solar_power'
  | 'vertical_shades_closed'
  | 'vertical_shades'
  | 'wind_power'
;

